import styled, { css } from "styled-components";
import { boxshadowMediumStyle } from "../../../styles/utils/Dropshadows.styles";
import * as UscCashPriceStyles from "../../price/UscCashPrice.styles";

export const Button = styled.button`
    display: flex;
    position: relative;
    flex: 1 0 50%;
    flex-direction: column;
    align-items: flex-start;
    padding-inline: calc(var(--spacing-3) / 2);
    padding-block: calc(var(--spacing-1) / 2) var(--spacing-1);
    border: 0;
    border-radius: 4px;
    user-select: none;
    &[aria-pressed="true"] {
        color: var(--color-primary-black);
        background-color: var(--color-primary-white);
        ${boxshadowMediumStyle};
    }

    @supports not (padding-inline: 0) {
        padding-top: calc(var(--spacing-1) / 2);
        padding-bottom: var(--spacing-1);
        padding-left: calc(var(--spacing-3) / 2);
        padding-right: calc(var(--spacing-3) / 2);
    }
`;

export const Wrapper = styled.div<{ enableMonthly: boolean }>`
    display: flex;
    flex-direction: row;
    padding: var(--spacing-1);
    background-color: var(--color-grey-4);
    border: 2px solid transparent;
    border-radius: 8px;

    ${({ enableMonthly }) =>
        !enableMonthly &&
        css`
            padding: calc(var(--spacing-1) / 2) 0 var(--spacing-1) 0;
            background-color: var(--color-primary-white);
            border-color: var(--color-grey-6);
            border-radius: 4px;

            ${Button} {
                box-shadow: none;
            }
        `};
`;

export const ButtonTitle = styled.span<{ isLoading?: boolean }>`
    font-family: var(--font-semi-bold);
    font-size: 1.6rem;
    line-height: 2rem;

    ${({ isLoading }) =>
        isLoading &&
        css`
            color: var(--color-grey-7);

            ${UscCashPriceStyles.Cash} {
                color: var(--color-grey-7);
            }
        `};
`;

export const ButtonDescription = styled.span`
    &,
    & > span {
        font-family: var(--font-regular);
        font-size: 1.3rem;
        line-height: 2rem;
    }
`;

export const LoadingIconWrapper = styled.div`
    position: absolute;
    inset-block-end: 16px;
    inset-inline-end: 20px;

    @supports not (padding-inline: 0) {
        bottom: 16px;
        right: 20px;

        [dir="rtl"] & {
            left: 20px;
            right: auto;
        }
    }
`;
